// Single switch for forcing account creation. Today auth is opt-in: the app
// works fully on-device and signup is skippable. Flip this on (set
// VITE_AUTH_REQUIRED=true at build time) to:
//   1. hide the "Skip" button on the post-coach signup gate, and
//   2. redirect protected routes to the gate when there's no session.
// Because all data already round-trips through /me/claim + boot-sync, flipping
// this changes navigation only — no data-flow or API change.
export const AUTH_REQUIRED = import.meta.env.VITE_AUTH_REQUIRED === 'true';

// Show the "Continue with Google" buttons. Off by default — flip to "true"
// (VITE_GOOGLE_OAUTH_ENABLED=true at build time) only once the Google OAuth
// client + GOOGLE_CLIENT_ID/SECRET are configured on the API, otherwise the
// button leads to a broken provider.
export const GOOGLE_OAUTH_ENABLED = import.meta.env.VITE_GOOGLE_OAUTH_ENABLED === 'true';
